module.exports = "<app-consultas-externas [isInserted]=\"true\"></app-consultas-externas>"